var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"emojy-box"},[(_vm.newMsg != '')?_c('span',{domProps:{"innerHTML":_vm._s(_vm.newMsg)}}):_vm._e(),(_vm.newMsg == '')?_c('span',[_vm._v(_vm._s(_vm.expressionData))]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }